export default __webpack_public_path__ + "static/media/female-profile-icon.d55edd28.svg";